import { nanoid } from 'nanoid'
import { AxiosError } from 'axios'
import { type ActionItem, toastStore } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { type IUser } from 'entities/Users'
import { type RowInbox } from 'entities/Inbox/model/Table/RowInbox'
import { InboxesApi } from 'entities/Inbox'

export const removeFromInboxAction = (
  member: IUser,
  inbox: RowInbox,
  onSuccess?: () => void | Promise<void>
) => {
  const modalId = nanoid()

  modalStore.addModal({
    id: modalId,
    type: ModalTypeList.ALERT,
    title: 'Remove from inbox?',
    desc: 'This member will lose access to all conversations in this inbox',
    primaryAction: {
      text: 'Yes, remove',
      onAction: async () => {
        try {
          await InboxesApi.deleteMember(inbox.id, member.id)
          inbox.origin.removeMemberId(member.id)
          toastStore.add({
            type: 'success',
            title: 'Member removed from inbox',
          })

          onSuccess?.()
          modalStore.closeModal(modalId)
        } catch (e) {
          logger.error(e)

          if (e instanceof AxiosError) {
            const message = e.errors.getError('message')
            if (message) {
              toastStore.add({
                type: 'info',
                title: `Can't remove from ${inbox.name} inbox`,
                desc: message,
              })
              return
            }
          }

          toastStore.add({
            type: 'error',
            title: 'Something went wrong. Please try again',
          })
        }
      },
    },
    secondaryAction: {
      text: 'Cancel',
      onAction: () => {
        modalStore.closeModal(modalId)
      },
    },
  })
}

export const removeFromInbox = (
  member: IUser,
  inbox: RowInbox,
  onSuccess?: () => void | Promise<void>
): ActionItem => {
  return {
    text: 'Remove from inbox',
    icon: 'delete',
    onAction: () => {
      removeFromInboxAction(member, inbox, onSuccess)
    },
  }
}
